// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_STRUCTURE_TYPES,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getStructureTypes = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('structure_types')
      .then(
        (response) => {
          dispatch(GET_STRUCTURE_TYPES, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/structureTypesActions.js